export default "__VITE_ASSET__c9293802__$_?nuxt_component=async__"